import {
  FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTORDERVIEW_INIT_ACTION,
  FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderDetails: action.payload.rows,
        chemistOrdersCount: action.payload.count
      };
    case FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION:
      return {
        ...state,
        chemistOrderDtls: action.payload.rows,
        chemistOrderDtlsCount:action.payload.count,
      };
   /*  case FETCH_CHEMISTORDERVIEW_INIT_ACTION:
      return {
        ...state,
        chemistOrderDtls: {}
      }; */

    /*       case FETCH_CHEMISTORDERESEARCH_SUCCESS_ACTION:
        return {
          ...state,
          chemistuserSearchList: action.payload.rows,
          chemistuserSearchCount: action.payload.count
        };
      case FILTER_BY_CHEMISTORDER_STATUS_SUCCESS_ACTION:
        return {
          ...state,
          chemistuserFilterList: action.payload.rows,
          chemistuserFilterCount: action.payload.count
        };
      case FETCH_CHEMISTDETAILSVIEW_INIT_ACTION:
        return {
          ...state,
          chemistmainDtls: {}
        };
 */
    default:
      return {
        ...state
      };
  }
}
